import { Link } from 'react-router-dom';
import { site } from '@/config/site';
import styles from './Logo.module.css';

interface LogoProps {
  /** Removes the link wrapper (e.g. when already inside a link context). */
  plain?: boolean;
}

export function Logo({ plain = false }: LogoProps) {
  const mark = (
    <img
      className={styles.logoImg}
      src="/logo.png"
      alt={site.name}
      height={44}
    />
  );

  if (plain) return mark;

  return (
    <Link to="/" className={styles.link} aria-label={`${site.name} home`}>
      {mark}
    </Link>
  );
}
